/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
} from 'lib';
*/
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as hfXLS from "./_hfXLS";

import * as ihd from './ihd';

import * as icvI18___Mz from './icvI18___Mz';

export const eptExlAsync = async (pz: {
  _31r_fst: ht.n,
//  i18rs: ht.ls,
}) => {

  const _i18rs = await icvI18___Mz.loadI18rLsAsync({
    _31r_fst: pz._31r_fst,
    lwrType: 1,
  });

  const _fileName = `団体一覧_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;

  const _hdrs = [
    { key:  1, header: '団体番号', width: 20, style: {} },
    { key:  2, header: '団体名', width: 20, style: {}  },
    { key:  3, header: '団体かな', width: 20, style: {}  },
    { key:  4, header: '代表者名', width: 20, style: {}  },
    { key:  5, header: '代表者かな', width: 20, style: {}  },
    { key:  6, header: '郵便番号', width: 20, style: {}  },
    { key:  7, header: '都道府県', width: 20, style: {}  },
    { key:  8, header: '市区町番地', width: 20, style: {}  },
    { key:  9, header: '建物・部屋番等', width: 20, style: {}  },
    { key: 10, header: '電話（主）', width: 20, style: {}  },
    { key: 11, header: '電話（副）', width: 20, style: {}  },
    { key: 12, header: 'メール（主）', width: 20, style: {}  },
    { key: 13, header: 'メール（副1）', width: 20, style: {}  },
    { key: 14, header: 'メール（副2）', width: 20, style: {}  },
    { key: 15, header: '次回更新日', width: 20, style: {}  },
    { key: 16, header: '１年目確認', width: 20, style: {}  },
    { key: 17, header: '２年目確認', width: 20, style: {}  },
    { key: 18, header: '３年目確認', width: 20, style: {}  },
    { key: 19, header: '更新メモ', width: 20, style: {}  },
    { key: 20, header: 'ジャンル', width: 20, style: {}  },
    { key: 21, header: '活動内容', width: 20, style: {}  },
    { key: 22, header: '活動備考', width: 20, style: {}  },
    { key: 23, header: '活動頻度', width: 20, style: {}  },
    { key: 24, header: '活動時間帯', width: 20, style: {}  },
    { key: 25, header: '活動曜日', width: 20, style: {}  },
    { key: 26, header: '会員構成', width: 20, style: {}  },
    { key: 27, header: '会員構成その他', width: 20, style: {}  },
    { key: 28, header: '男性人数', width: 20, style: {}  },
    { key: 29, header: '女性人数', width: 20, style: {}  },
    { key: 36, header: '大人人数', width: 20, style: {}  },
    { key: 30, header: 'こども人数', width: 20, style: {}  },
    { key: 31, header: '会費', width: 20, style: {}  },
    { key: 32, header: '会員募集', width: 20, style: {}  },
    { key: 33, header: '指導者名', width: 20, style: {}  },
    { key: 34, header: '指導者かな', width: 20, style: {}  },
    { key: 35, header: '利用制限', width: 20, style: {}  },
  ];

  let _bdys = [] as ht.ls;
  _i18rs?.map((_i18rz: ht.dz) => {
    const _i16rz = hf.get1(_i18rz?.cldz?.i16rs, {});
    _bdys.push({
      1: _i18rz.i18rab100s,
      2: _i18rz._pfx,
      3: _i18rz.i18ra1100s,
      4: _i18rz.i18ra2110s,
      5: _i18rz.i18ra2120s,
      6: _i18rz.i18ra3100s,
      7: _i18rz.i18ra3200s,
      8: _i18rz.i18ra3300s,
      9: _i18rz.i18ra3400s,
    10: _i18rz.i18ra3510s,
    11: _i18rz.i18ra3520s,
    12: _i18rz.i18ra4110s,
    13: _i18rz.i18ra4210s,
    14: _i18rz.i18ra4310s,
    15: _i18rz.i18ra5100s,
    16: ihd.r(ihd.f('i18ra5210i').ls, _i18rz.i18ra5210i),
    17: ihd.r(ihd.f('i18ra5220i').ls, _i18rz.i18ra5220i),
    18: ihd.r(ihd.f('i18ra5230i').ls, _i18rz.i18ra5230i),
    19: _i18rz.i18ra5300s,
    20: _i16rz?._pfx,
    21: _i18rz.i18ra6100s,
    22: _i18rz.i18ra6200s,
    23: `${ihd.r(ihd.f('i18ra6310i').ls, _i18rz.i18ra6310i)} ${_i18rz.i18ra6320i}回`,
    24: ihd.r(ihd.f('i18ra6400i').ls, _i18rz.i18ra6400i),
    25: _i18rz.i18ra6500s,
    26: ihd.r(ihd.f('i18ra7100i').ls, _i18rz.i18ra7100i),
    27: _i18rz.i18ra7200s,
    28: _i18rz.i18ra7310i,
    29: _i18rz.i18ra7320i,
    36: _i18rz.i18ra7330i,
    30: _i18rz.i18ra7340i,
    31: `${ihd.r(ihd.f('i18ra8100i').ls, _i18rz.i18ra8100i)} ${_i18rz.i18ra8200i}円`,
    32: ihd.r(ihd.f('i18ra8300i').ls, _i18rz.i18ra8300i),
    33: _i18rz.i18ra9110s,
    34: _i18rz.i18ra9120s,
    35: ihd.r(ihd.f('i18rt1100i').ls, _i18rz.i18rt1100i),
    });
  });

  hfXLS.saveAsync({
    fileName: _fileName,
    shts: [{
      shtName: '団体一覧',
      hdrs: _hdrs,
      bdys: _bdys,
    }]
  })

};
